// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"7994f5bf","453":"3ab7c11e"}[chunkId] + ".chunk.js";
};